import React from 'react';
import Modal from '../../../../components/base/Modal';
import ModalFooter from '../../../../components/base/Modal/ModalFooter';
import ModalTitle from '../../../../components/base/Modal/ModalTitle';
import styles from '../../../../components/ui/modals/ConfirmModal/ConfirmModal.module.scss';

const ColorWarningModal = ({ onCancel, onContinue }) => (
  <Modal onCancel={onCancel}>
    <ModalTitle title="Low Contrast Warning" />
    <div className={styles.description}>
      <p>
        <span>
          The text color and background color in your form fields are very
          similar, which may make the text hard to read.
        </span>
      </p>
      <p>
        <span>Do you want to continue anyway?</span>
      </p>
    </div>
    <ModalFooter>
      <button
        type="button"
        className="outline-button border"
        onClick={onCancel}
      >
        Go Back
      </button>
      <button type="button" className="regular-button" onClick={onContinue}>
        Continue Anyway
      </button>
    </ModalFooter>
  </Modal>
);

export default ColorWarningModal;
